const isClient = (force?: boolean | undefined): boolean =>
  typeof force === 'boolean' ? force : typeof window !== 'undefined';

const hasValueInUrl = (value: string): boolean => (isClient() ? window.location.href.includes(value) : false) ?? false;

const LABEL_F1: string = 'Sprint Race';
const LABEL_MOTOGP: string = 'Gara Sprint';
const SELECTOR_CALENDAR: string =
  'ld-motorsports-competition-calendar .ftbl__motorsports-calendar-page .ftbl__motorsports-session-row__content .ftbl__motorsports-session-row__body .ftbl__motorsports-session-row__body-session-name';
const SELECTOR_RESULTS: string =
  'ld-motorsports-current-calendar .ftbl__motorsports-gp-sessions .ftbl__motorsports-session-row__content .ftbl__motorsports-session-row__body .ftbl__motorsports-session-row__body-session-name';
const SELECTOR_TABS: string = '.ftbl__tabs-menu .ftbl__tab-item .ftbl__tab-item__label';
const SELECTORS: string[] = [SELECTOR_CALENDAR, SELECTOR_RESULTS, SELECTOR_TABS];

export const checkSprintRaceLabel = () => {
  if (hasValueInUrl('motogp')) {
    SELECTORS.forEach((selector: string) => {
      const labelElements: NodeListOf<Element> = document.querySelectorAll(selector);
      labelElements.forEach((element: Element) => {
        // console.log('checkSprintRaceLabel', element.innerHTML);
        element.innerHTML = element.innerHTML.replace(LABEL_F1, LABEL_MOTOGP);
      });
    });
  }
};
